import React from 'react';
import { companyInfo } from './mock';
import { Mail, Phone, MapPin, Share2 } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold mb-4">🧵 Endemik Solutions</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Your trusted partner in authentic shawl testing and verification since 2010.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/" className="text-gray-400 hover:text-teal-400 transition">Home</a></li>
              <li><a href="/about" className="text-gray-400 hover:text-teal-400 transition">About Us</a></li>
              <li><a href="/book" className="text-gray-400 hover:text-teal-400 transition">Book Appointment</a></li>
              <li><a href="/contact" className="text-gray-400 hover:text-teal-400 transition">Contact</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold mb-4">Services</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="<button onClick={handleClick}>Link</button>" className="text-gray-400 hover:text-teal-400 transition">Pashmina Authentication</a></li>
              <li><a href="<button onClick={handleClick}>Link</button>" className="text-gray-400 hover:text-teal-400 transition">Adulteration Testing</a></li>
              <li><a href="<button onClick={handleClick}>Link</button>" className="text-gray-400 hover:text-teal-400 transition">Fiber Analysis</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold mb-4">Contact</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-start">
                <Mail className="w-4 h-4 mr-2 mt-1 flex-shrink-0 text-teal-400" />
                <span className="text-gray-400">{companyInfo.email}</span>
              </div>
              <div className="flex items-start">
                <Phone className="w-4 h-4 mr-2 mt-1 flex-shrink-0 text-teal-400" />
                <span className="text-gray-400">{companyInfo.phone}</span>
              </div>
              <div className="flex items-start">
                <MapPin className="w-4 h-4 mr-2 mt-1 flex-shrink-0 text-teal-400" />
                <span className="text-gray-400 text-xs">{companyInfo.address}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <hr className="border-gray-700 my-8" />

        {/* Bottom */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm text-center md:text-left mb-4 md:mb-0">
            © {currentYear} Endemik Solutions Private Limited. All rights reserved.
          </p>
          
          {/* Social Links */}
          <div className="flex space-x-6">
            <a href="<button onClick={handleClick}>Link</button>" className="text-gray-400 hover:text-teal-400 transition">
              Facebook
            </a>
            <a href="<button onClick={handleClick}>Link</button>" className="text-gray-400 hover:text-teal-400 transition">
              Twitter
            </a>
            <a href="<button onClick={handleClick}>Link</button>" className="text-gray-400 hover:text-teal-400 transition">
              LinkedIn
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
